<template>
   <div>
      <div v-show="this.shown && !this.locked">
         <div class="unit add_unit pointer" v-if="!conditionSet && !cdLoading">
            <span class="select-items flex-grow-1" v-if="!conditionSet && !open" @click="openOrClose"><i class="fal fa-plus-circle"></i><span>Select Items</span></span>
            <span class="select-items flex-grow-1" v-else @click="openOrClose"><i class="fal fa-arrow-circle-left"></i>Close</span>
            <transition name="slide-fade">
            <div v-if="open && !conditionSet" >
               <SearchBar
                  :placeHolder="'Filter items'"
                  :characterLimit="0"
                  @click="sendSearch"
                  @term="filterSearch"
                  :lite="true"
               />
            </div>
            </transition>
         </div>
         <div v-if="conditionSet || cdLoading">
            <div class="option-search">
               <div class="condition-icons">
                  <i v-if="cdLoading && !this.open" class="fas fa-circle-notch fa-spin theme-calc rel-loader"></i>
               </div>
               <div class="condition-search">
                  <SearchBar
                     :placeHolder="'Search for an item'"
                     :characterLimit="0"
                     :disabled="cdLoading"
                     @click="sendSearch"
                  />
               </div>
            </div>
         </div>
      </div>
      <div :class="this.open ? 'selection-box' : ''" @scroll="onScroll">
         <div v-if="sortedRelationship.length == 0 && !cdLoading && this.open">No items were found</div>
         <span v-if="sortedRelationship">
            <Relationship v-for="sr in sortedRelationship" :key="sr.code+'-'+sr.order" v-show="isShown(sr)" :data="sr" :location="location+'>'+sr.code+'-'+sr.order" @creditUpdate="updateCredits" @clicked="addRemoveItem" />
         </span>
         <div v-if="cdLoading && this.open"><Loading/></div>
      </div>
   </div>
</template>

<script>
   import { mapState, mapActions } from 'vuex'
   import {dynamicSort} from 'common/models/sorting.js'

   import Relationship from './relationship.vue'
   export default {
      components: {
         Relationship
      },
      props: {
         data: {
            type: Array,
            required: true
         },
         requiredCredits: {
            type: Number,
            required: true
         },
         location: {
            type: String,
            required: false,
         },
         conditionSet: {
            type: Boolean,
            required: false,
            default: false,
         },
         cdLoading: {
            type: Boolean,
            required: false,
            default: false,
         }
      },
      data: function(){
         return {
            open: false,
            shown: true,
            credits: 0,
            selected: [],
            loading: false,
            searchShown: false,
            filter: "",
         }
      },
      mounted: function(){
      },
      computed: {
         ...mapState({
            selectedItems: state => state.selections.selectedItems,
            locked: state => state.selections.locked,
         }),
         orderedRelationship: function(){
            return this.data.sort( dynamicSort("order") );
         },
         unselectedRelationships: function(){
            var ur = this.orderedRelationship.filter(x => !this.selected.some(y => y.id == x.id));
            if(this.filter){
               ur = ur.filter(x => x.code.toLowerCase().includes(this.filter.toLowerCase()) || x.name.toLowerCase().includes(this.filter.toLowerCase()))
            }
            return ur
         },
         sortedRelationship: function(){
            var sr = this.selected.concat(this.unselectedRelationships);
            return sr;
         },
         actualCreds: function(){
            var actCred = 0;
            for(var i=0; i<this.selected.length; i++){
               actCred = actCred + parseFloat(this.selected[i].credits);
            }
            return actCred;
         },
      },
      methods: {
         ...mapActions([
         ]),
         openOrClose() {
            if(!this.conditionSet || this.open){
               this.open = !this.open;
            }
            if(this.open && !this.conditionSet){
               this.searchCollapsed = false;
            }else if(!this.conditionSet){
               this.searchCollapsed = true;
            }

         },
         updateCredits(c){
            this.credits = this.credits + c;
         },
         isShown(val) {
            return (this.open || this.selected.filter(unit => unit.id === val.id).length > 0)
         },
         addRemoveItem(val) {
            if(this.selected.filter(unit => unit.id === val.id).length === 0) {
               this.selected.push(val)
            }else {
               this.selected = this.selected.filter(unit => unit.id != val.id);
            }
         },
         onScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
            if (scrollTop + clientHeight >= scrollHeight) {
               this.$emit('getNextPage');
            }
         },
         addLocation(d){
            d.location = this.location+'>'+d.code+'-'+d.order;
            return d
         },
         sendSearch(val){
            if(this.conditionSet){
               this.open = true;
               this.loading = true;
               this.$emit('searchOptionalRelationships', val);
            }else{
               this.filter = val;
            }
         },
         filterSearch(val){
            if(!this.conditionSet){
               //console.log(val)
               this.filter = val;
            }
         },
         openSearch(){
            this.searchCollapsed = false;
         }
      },
      watch: {
         //immediate: true,
         credits: function(newVal, oldVal) {
            this.$emit('creditUpdate', newVal-oldVal);
         },
         actualCreds: function(val) {
            if(this.actualCreds >= this.requiredCredits){
               this.open = false;
               this.shown = false;
            }else{
               this.open = true;
               this.shown = true;
            }
         },
         sortedRelationship: function(){
            this.loading = false;
         },
         conditionSet: function(){
            this.searchCollapsed = !this.conditionSet;
         }
      }
   }
</script>

